import { useScrollTop } from '@hivebrite/react-hooks';

import { NAVIGATION } from 'hb-react/shared/apps/Events/constants/navigation';
import { useWithBillingStepWorkflow } from 'hb-react/shared/apps/Events/hooks/useWithBillingStepWorkflow';

export const useNavigation = () => {
  const withBillingStepWorkflow = useWithBillingStepWorkflow();

  useScrollTop([]);

  return [
    {
      name: NAVIGATION.TICKET_SELECTION,
      disabled: true,
    },
    {
      name: NAVIGATION.REGISTRATION,
      disabled: true,
    },
    ...(withBillingStepWorkflow
      ? [
          {
            name: NAVIGATION.BILLING_DETAILS,
            disabled: true,
          },
        ]
      : []),
    {
      name: NAVIGATION.PAYMENT,
      active: true,
      requiredExplanation: true,
    },
  ];
};
